module.exports = __webpack_public_path__ + "static/surveys.be97984d.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/surveys.jpg
// module id = 551
// module chunks = 0